const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/**
 * Returns true when `value` is a well-formed UUID (version-agnostic, case-insensitive).
 * Use this instead of duplicating the regex inline.
 */
export function isUuid(value: string): boolean {
  return UUID_RE.test(value);
}
